var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"DETTAGLIO ANNO"}},[(_vm.loading)?_c('Spinner'):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"height":"400px"},attrs:{"id":_vm.chartId}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5884757b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/VectorWidgets/widgets/ConsumptionMonthly.vue
// module id = null
// module chunks = 